<template>
    <path d="M19.315999,8.246c0.008,0.162 0.011,0.326 0.011,0.488c0,4.99 -3.797,10.742 -10.74,10.742c-2.133,0 -4.116,-0.625 -5.787,-1.697 c0.296,0.035 0.596,0.053 0.9,0.053c1.77,0 3.397,-0.604 4.688,-1.615c-1.651,-0.031 -3.046,-1.121 -3.526,-2.621 c0.23,0.043 0.467,0.066 0.71,0.066c0.345,0 0.679,-0.045 0.995,-0.131c-1.727,-0.348 -3.028,-1.873 -3.028,-3.703c0,-0.016 0,-0.031 0,-0.047 c0.509,0.283 1.092,0.453 1.71,0.473c-1.013,-0.678 -1.68,-1.832 -1.68,-3.143c0,-0.691 0.186,-1.34 0.512,-1.898 c1.861,2.285 4.644,3.787 7.781,3.945c-0.064,-0.277 -0.097,-0.564 -0.097,-0.861c0,-2.084 1.689,-3.773 3.774,-3.773 c1.086,0 2.067,0.457 2.756,1.191c0.859,-0.17 1.667,-0.484 2.397,-0.916c-0.282,0.881 -0.881,1.621 -1.66,2.088 c0.764,-0.092 1.49,-0.293 2.168,-0.594c-0.506,0.758 -1.146,1.422 -1.884,1.953z"/>
</template>

<script>
    export default {
        name: 'twitter',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Twitter.vue